import { Toast } from '../../interfaces';
import { createAsyncAtom } from '../../lib';

const toastAtom = createAsyncAtom<Toast[]>(async () => []);

function addToast(toast: Toast) {
  const toasts = toastAtom.getResolvedValue();
  if (!toasts) {
    return;
  }

  const filteredToasts = toasts.filter(t => t.txId !== toast.txId);

  toastAtom.setValue([toast, ...filteredToasts]);
}

function removeToast(toast: Toast) {
  const toasts = toastAtom.getResolvedValue();
  if (!toasts) {
    return;
  }

  const filteredToasts = toasts.filter(t => t.id !== toast.id);

  toastAtom.setValue(filteredToasts);
}

export default toastAtom;

export { addToast, removeToast };
